import React from 'react';
import { Container, Header, Logo, Content, Footer } from './styles';
import logoImg from '@/assets/images/capivara-min.png';

export const Privacy: React.FC = () => {
  return (
    <Container>
      <Header>
        <Logo src={logoImg} alt="Logo" />
      </Header>
      <Content>
        <h1>Política de Privacidade</h1>
        <p>
          Bem-vindo à nossa Política de Privacidade. Este documento informa como coletamos, usamos e protegemos 
          seus dados pessoais ao utilizar nossos serviços.
        </p>

        <h2>Coleta de Informações</h2>
        <p>
          Nós coletamos dados como nome, e-mail, informações de login e outros dados necessários para oferecer um melhor atendimento.
        </p>

        <h2>Uso dos Dados</h2>
        <p>
          Os dados coletados são utilizados para personalizar sua experiência, melhorar nossos serviços e oferecer suporte adequado.
        </p>

        <h2>Segurança</h2>
        <p>
          Adotamos diversas medidas de segurança para proteger os seus dados contra acessos não autorizados.
        </p>

        <h2>Alterações nesta Política</h2>
        <p>
          Esta política pode ser atualizada periodicamente. Recomendamos que a revise regularmente.
        </p>
      </Content>
      <Footer>
        <p>&copy; {new Date().getFullYear()} Puxa Capivara. Todos os direitos reservados.</p>
      </Footer>
    </Container>
  );
};
